const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.03,14.05c0,3.88-3.15,7.03-7.03,7.03s-7.03-3.15-7.03-7.03,3.15-7.03,7.03-7.03v4.68l5.85-5.85L12,0v4.68c-5.18,0-9.37,4.19-9.37,9.37s4.19,9.37,9.37,9.37,9.37-4.19,9.37-9.37h-2.34Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.67 17.49 10.67 12.49 10.56 12.49 8.49 13.23 8.49 14.04 9.67 13.68 9.67 17.49 10.67 17.49",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.29,14.57v.87c0,2.22,1.53,2.13,1.69,2.13.16,0,1.69.11,1.69-2.13v-.87c0-2.22-1.53-2.13-1.69-2.13-.16,0-1.69-.11-1.69,2.13ZM14.68,14.43v1.14c0,.9-.25,1.21-.69,1.21s-.7-.3-.7-1.21v-1.14c0-.88.26-1.18.69-1.18.44-.01.7.3.7,1.18Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward10);
export default __webpack_public_path__ + "static/media/forward10.2e527374025050d99a9cdd18ff8a77b2.svg";
export { ForwardRef as ReactComponent };